import cn from "classnames";
import { Grid } from "@rshbintech.dboul/core-ui";
import { SpecialOfferApiEnums } from "@rshbintech.dboul/http";
import { SpecialOffer } from "../special-offer";
import { HeaderProps } from "./types";
import styles from "./styles.scss";

export const Header = ({
  children,
  headerContentClassName,
  headerClassName,
  specialOfferSettings,
}: HeaderProps) => (
  <header className={cn(styles.header, headerClassName)}>
    <div className={styles["header-content"]}>
      <Grid className={cn(styles.grid, headerContentClassName)}>
        {children}
      </Grid>
    </div>
    {specialOfferSettings && (
      <SpecialOffer
        name={specialOfferSettings.name}
        type={SpecialOfferApiEnums.SpecialOfferTypeEnum.HEADER}
        analyticsSettings={specialOfferSettings?.analyticsSettings}
        className={cn(styles["special-offer"], specialOfferSettings?.className)}
        dataTestId={specialOfferSettings?.dataTestId}
      />
    )}
  </header>
);
